/*
 * Copyright (c) 2023 Bluemate B.V.
 */
import './style/confirmCheckout.scss';

import React, {useContext, useState} from 'react';

import {AppContext} from '../misc/appContext';

import {useEvent} from '@dvrd/dvr-controls';

import {BluemateButton} from '../controls';

import Image from '../misc/image';

export default function ConfirmCheckout() {
    const {userContext} = useContext(AppContext);
    const [active, setActive] = useState(false);
    const [headerHeight, updateHeaderHeight] = useState(0);
    useEvent('onConfirmCheckout', onActivate);
    const header = React.useRef<HTMLDivElement>(null);

    function onActivate() {
        setActive(true);
    }

    function setHeaderHeight() {
        if (header.current) updateHeaderHeight(header.current.getBoundingClientRect().height);
    }

    if (!active) return null;
    return (
        <div className='confirm-checkout'>
            <div className='logo-header' ref={header}>
                <Image name='logo' className='logo' onLoad={setHeaderHeight} />
            </div>
            <div style={{height: `${headerHeight}px`}} />
            <div>
                <div className='content'>
                    <label className='header-title'>Abonnement succesvol afgesloten</label>
                    <Image name='logo-no-text-big' className='content-logo' />
                    <p className='message'>
                        Bedankt {userContext.user?.firstname ?? ''} 🙌
                        <br />
                        Met vriendelijke groet,
                        <br />
                        Team Bluemate
                    </p>
                    <BluemateButton
                        onClick={() => {
                            setActive(false);
                        }}
                        label='Sluiten'
                        className='close-btn'
                    />
                </div>
            </div>
        </div>
    );
}
